
  import Vue from "vue";
  import { Component, Prop, Watch } from "vue-property-decorator";
  import { GREEN_MAP_PIN_ICON, MAP_STYLES } from "@/consts";
  
  @Component({
    data: () => {
      return {
        customBus: new Vue(),
      };
    },
  })

  export default class BarcodeOrderMap extends Vue {
    @Prop({ required: false, default: () => null })
    @Prop({ required: true }) pins: any[];
    @Prop({ required: false }) selectedPinIndex: number;  

    public orders: any[];
    public loaded: boolean = false;

    pinInfoWindowOpened: boolean = false;
    pinInfoWindowOptions: any = null;
    pinInfoWindowPos: any = null;
    mapCenter: any = null;
    mapZoomLevel: number = 10;
  
    @Watch("pins", { immediate: true })
    onOrdersChange(val: any[]) {
        var mapInfo = this.getPinMapLocation();
        this.mapCenter = { lat: mapInfo.latCenter, lng: mapInfo.lngCenter };
        this.mapZoomLevel = mapInfo.zoomLevel;
        this.loaded = true;
    }

    @Watch("selectedPinIndex", {immediate: true})
    onSelectedPinIndexChange(val: number) {
        if (val < 0 || val > this.pins.length - 1) return;
        this.selectMapPin(this.pins[val]);
    }

    getPinMapLocation() {
        let minLat = 180,
            maxLat = -180,
            minLng = 180,
            maxLng = -180,
            latCenter = null,
            lngCenter = null,
            zoomLevel = null;

        this.pins.forEach(pin => {
            maxLat = maxLat < pin.latitude ? pin.latitude : maxLat;
                minLat = minLat > pin.latitude ? pin.latitude : minLat;
                maxLng = maxLng < pin.longitude ? pin.longitude : maxLng;
                minLng = minLng > pin.longitude ? pin.longitude : minLng;
        });

        let newLatCenter = (minLat + maxLat) / 2;
        let newLngCenter = (minLng + maxLng) / 2;
        let maxDegree = maxLat - minLat > maxLng - minLng ? maxLat - minLat : maxLng - minLng;
        if (newLatCenter !== 0 && newLngCenter !== 0) {
            latCenter = newLatCenter;
            lngCenter = newLngCenter;
        }
        if (maxDegree != -360) {
            let newZoomLevel = Math.abs(Math.floor(Math.log2(1 / (180 / maxDegree))));
            zoomLevel = newZoomLevel > 17 ? 17 : newZoomLevel;
        }
        return {
            latCenter: latCenter,
            lngCenter: lngCenter,
            zoomLevel: zoomLevel
        };
    }

    getPinPosition(pin: any) {
        return { lat: pin?.latitude ?? 0, lng: pin?.longitude ?? 0 };
    }
  
    getPinMapIcon() {
      return GREEN_MAP_PIN_ICON;
    }

    getPinMapLabel(pin: any) {
        return pin.ordinal.toString();
    }
  
    getMapOptions() {
      return MAP_STYLES;
    }

    selectMapPinIndex(pinIndex: number) {
        this.selectMapPin[this.pins[pinIndex]];
    }

    selectMapPin(pin: any) {
        this.pinInfoWindowOpened = pin != null;
        this.pinInfoWindowOptions = this.getPinInfoWindowOptions(pin);
        this.pinInfoWindowPos = this.getPinPosition(pin);
    }
  
    getPinInfoWindowOptions(pin: any) {
        return this.buildPinText(pin);
    }

    buildPinText(pin: any) {
        if(pin == null ){
            return { content: "" };
        }

        // Header
        var text = `<div class="w-95"><div class="container mb-2"><div class="row pt-2 pb-3"><div class="col-12 field-title text-center">Location #${pin.ordinal}</div></div></div></div>`;

        // Details with alternating color
        var toggleColor = true;       
        pin.barcodes.forEach(barcode => {
            text += `<div class="container order-container pb-2 ${toggleColor ? "bg-light" : "bg-white"}">`;
            text += `<div class="row pt-1"><div class="col-12">Barcode: ${barcode.barcode}</div></div>`;
            text += `<div class="row"><div class="col-12">Commodity Code: ${barcode.commodityCode}</div></div>`;
            text += `<div class="row"><div class="col-12">Quantity: ${barcode.quantity}</div></div>`;
            text += `<div class="row"><div class="col-12">Status: ${barcode.status}</div></div>`;
            text += "</div>";
            toggleColor = !toggleColor;
        });

        text += '</div></div>';
        return { content: text };
    }
  }
